import { TextField as MaterialTextField } from '@mui/material';
import React from 'react';

import { TextFieldProps } from './TextField.props';
import { SizeProps } from '../../../@types';

export const TextField: React.FC<TextFieldProps> = ({
  variant,
  className,
  required = false,
  multiline = false,
  autoFocus = false,
  placeholder,
  rows,
  label,
  defaultValue,
  value,
  helperText,
  error,
  disabled = false,
  fullWidth = false,
  onChange,
  onBlur,
  InputLabelProps,
  InputProps,
  inputProps,
  size = SizeProps.Small,
  inputRef,
  type,
  onKeyDown,
  onFocus
}) => {
  return (
    <MaterialTextField
      className={className}
      variant={variant}
      required={required}
      multiline={multiline}
      placeholder={placeholder}
      label={label}
      defaultValue={defaultValue}
      value={value}
      rows={rows}
      helperText={helperText}
      error={error}
      disabled={disabled}
      fullWidth={fullWidth}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange?.(event.target.value)}
      onBlur={(event: React.FocusEvent<HTMLInputElement>) => onBlur?.(event.target.value)}
      InputLabelProps={InputLabelProps}
      InputProps={InputProps}
      inputProps={inputProps}
      size={size}
      inputRef={inputRef}
      type={type}
      onKeyDown={onKeyDown}
      autoFocus={autoFocus} // eslint-disable-line jsx-a11y/no-autofocus -- passthrough prop, defaults to false
      onFocus={onFocus}
    >
    </MaterialTextField>
  );
};
